import { Box } from "@design-system/Layout/Box";

import { Text } from "@design-system/Typography/Text";
import { FC } from "react";
import { ReactComponent as SwitchDisabled } from "./switch-disabled.svg";
import { ReactComponent as SwitchOff } from "./switch-off.svg";
import { ReactComponent as SwitchOnAccent } from "./switch-on-accent.svg";
import { ReactComponent as SwitchOnDefault } from "./switch-on-default.svg";
import { ReactComponent as SwitchOnHelper } from "./switch-on-helper.svg";

type SwitchProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    type?: "default" | "helper" | "accent";
    label?: string;
    labelPosition?: "left" | "right";
    disabled?: boolean;
};

export const Switch: FC<SwitchProps> = ({
    checked,
    onChange,
    type,
    label,
    labelPosition,
    disabled,
}) => {
    const handleClick = () => {
        onChange(!checked);
    };
    return (
        <Box
            alignItems="center"
            display="flex"
            gap="2"
            direction={labelPosition === "right" ? "row-reverse" : "row"}
        >
            <Text whitespace="nowrap" color={disabled ? "disabled" : "primary"}>
                {label}
            </Text>
            <button onClick={handleClick} disabled={disabled}>
                {checked ? (
                    type === "helper" ? (
                        <SwitchOnHelper />
                    ) : type === "accent" ? (
                        <SwitchOnAccent />
                    ) : (
                        <SwitchOnDefault className="text-primary" />
                    )
                ) : disabled ? (
                    <SwitchDisabled />
                ) : (
                    <SwitchOff />
                )}
            </button>
        </Box>
    );
};
